import React, { useState } from 'react'

import useToast from '../../../../hooks/useToast'
import { ButtonRound } from '../../../../components/Header/styles'
import Popup from 'reactjs-popup'
import { Container, Title } from './styles'
import { FaUsers } from 'react-icons/fa6'
import UsersSearch from '../FileDetails/GroupsSearch'

interface ModalUserPermissionProps {
  onSubmitButton: () => void
  fileRefs: any
}

const UserPerMission: React.FunctionComponent<ModalUserPermissionProps> = ({
  onSubmitButton,
  fileRefs,
}) => {
  const [documentId, setDocumentId] = useState<any>([])
  const toast = useToast()

  const onPressUsersPermission = () => {
    let ids: any = []

    fileRefs.current.map((ref: any) => {
      if (ref?.current?.checked) {
        ids.push(ref.current._id)
      }
    })
    if (ids.length > 0) {
      setDocumentId(ids)
    } else {
      setDocumentId([])
    }
  }

  return (
    <>
      <div id='portalMenuUsers' />
      <Popup
        trigger={
          <button
            type="button"
            data-tooltip-id='my-tooltip'
            data-tooltip-content='Permissões de usuários'
            data-tooltip-place='top'
            style={{
              width: 34,
              height: 34,
              minWidth: 34,
              borderRadius: 8,
              border: '1px solid rgba(0, 0, 0, 0.12)',
              backgroundColor: 'rgba(255, 255, 255, 0.5)',
              color: '#475569',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              cursor: 'pointer',
              transition: 'all 0.15s ease',
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.8)'
              e.currentTarget.style.color = '#0f172a'
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.5)'
              e.currentTarget.style.color = '#475569'
            }}
          >
            <FaUsers size={14} />
          </button>
        }
        onOpen={() => onPressUsersPermission()}
        position='bottom right'
      >
        <Container>
          <Title>{documentId.length} arquivo(s) selecionado</Title>
          {documentId.length && (
            <UsersSearch
              menuPortalTarget={document.querySelector('#portalMenuUsers')}
              menuPosition={'fixed'}
              fileId={documentId}
            />
          )}
        </Container>
      </Popup>
    </>
  )
}

export default UserPerMission
